import React from 'react';
import {observer} from "mobx-react";
import {BookingSearchFieldsContainerBox} from "../common/booking-search-fields-container.box";
import {SearchByEmailStrategy} from "./search-by-email.strategy";
import {BookingSearchCommonFieldsComponent} from "../common/booking-search-common-fields.component";
import {EmailFieldEditorComponent} from "../../../../components/forms/contact/email-field-editor.component";

export const SearchByEmailComponent: React.FC<{strategy: SearchByEmailStrategy}> = observer((props) => {

    const fields = props.strategy.fields;

    return (
        <BookingSearchFieldsContainerBox>
            <EmailFieldEditorComponent field={fields.email} showClearButton={true}/>
            <BookingSearchCommonFieldsComponent fields={fields}/>
        </BookingSearchFieldsContainerBox>
    )
})